import constant from '../api/constant';

/**
 * Special Posts admin API (SCRUM-247). The gateway maps `/api/v1/admins/special-post-types` to
 * admin-service `/admin/api/v1/special-post-types` like the other admin modules (the apps use
 * `/api/v1/special-post-types` on post-service, so the admin path must stay under `admins`).
 */
const PREFIX = '/api/v1/admins/special-post-types';

export class SpecialPostsApiError extends Error {
  statusCode?: number;

  type?: string;

  constructor(message: string) {
    super(message);
    this.name = 'SpecialPostsApiError';
    // WHY: the ES5 build loses the subclass prototype on Error unless it is restored by hand.
    Object.setPrototypeOf(this, SpecialPostsApiError.prototype);
  }
}

const toApiError = (error: any): SpecialPostsApiError => {
  const payload = error?.response?.data;
  const apiError = new SpecialPostsApiError(payload?.message || payload?.error || error?.message || 'Request failed');
  apiError.statusCode = payload?.statusCode ?? error?.response?.status;
  apiError.type = payload?.type;
  return apiError;
};

type Method = 'get' | 'post' | 'put' | 'delete';

async function call<T>(method: Method, path: string, body?: unknown, params?: Record<string, unknown>): Promise<T> {
  try {
    const res = await constant.axios.request({
      method, url: `${PREFIX}${path}`, data: body, params,
    });
    return res.data?.data as T;
  } catch (error) {
    throw toApiError(error);
  }
}

export const specialPostsGet = <T>(path: string, params?: Record<string, unknown>) => call<T>('get', path, undefined, params);
export const specialPostsPost = <T>(path: string, body: unknown) => call<T>('post', path, body);
export const specialPostsPut = <T>(path: string, body: unknown) => call<T>('put', path, body);
export const specialPostsDelete = <T>(path: string, body: unknown) => call<T>('delete', path, body);
